import { EMPTY_RECAL_PROPOSAL_SET_MODEL } from "presentation/model/RecalProposalSet/RecalProposalSetModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: RecalProposalSetProvider,
    useTracked: useRecalProposalSetTracked
} = createContainer(() => useState(EMPTY_RECAL_PROPOSAL_SET_MODEL), {concurrentMode: true});
export { RecalProposalSetProvider, useRecalProposalSetTracked };

